import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

import async from '@xanadu/ui-shared/components/asyncComponent';

import GlobalBannerPortal from '@xanadu/ui-shared/components/GlobalBannerPortal';
import { PRODUCT_ROUTES } from '../constants';

const AsyncLobby = async(() =>
  import('../containers/Casino').then(module => module.default)
);

const LobbyRouteHandler = ({ match: { params: { lobbyId, gameId, gameTitle } } }) => (
  <AsyncLobby lobbyId={lobbyId} gameId={gameId} gameTitle={gameTitle} />
);

LobbyRouteHandler.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      lobbyId: PropTypes.string,
      gameId: PropTypes.string,
      gameTitle: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

const Casino = ({ product }) => (
  <React.Fragment>
    <GlobalBannerPortal bigger />
    <Switch>
      <Route
        exact
        path={`${PRODUCT_ROUTES[product]}/:lobbyId?`}
        component={LobbyRouteHandler}
      />
      <Route
        path={`${PRODUCT_ROUTES[product]}/:lobbyId/:gameId/:gameTitle?`}
        component={LobbyRouteHandler}
      />
    </Switch>
  </React.Fragment>
);

Casino.propTypes = {
  product: PropTypes.string.isRequired,
};

export default Casino;
